import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=3acc638b&scoped=true"
import script from "./MainImage.vue?vue&type=script&lang=js"
export * from "./MainImage.vue?vue&type=script&lang=js"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=3acc638b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc638b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3acc638b')) {
      api.createRecord('3acc638b', component.options)
    } else {
      api.reload('3acc638b', component.options)
    }
    module.hot.accept("./MainImage.vue?vue&type=template&id=3acc638b&scoped=true", function () {
      api.rerender('3acc638b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/modules/MainImage.vue"
export default component.exports